function isEmpty(val) {
	return val === undefined || val === null || val.length <= 0 ? true : false;
}
function hasValue(val) {
	return val === undefined || val === null || val.length <= 0 ? false : true;
}
function initializeEnvironment() {
	//setupGlobalHandlers();
	setupFunctions();
	//setupCookieCheck();
	browserCheck();
}
//function setupGlobalHandlers() {
//    $(document).on("click", "a:not([data-bypass])", function (e) {
//        var href = { prop: $(this).prop("href"), attr: $(this).attr("href") };
//        //var root = location.protocol + "//" + location.host + app.root;
//        var root = location.protocol + "//" + location.host;

//        if (href.prop && href.prop.slice(0, root.length) === root) {
//            e.preventDefault();
//            //Backbone.history.navigate(href.attr, true);
//            pf.navigate(href.attr);
//        }
//    });
//    $("#mobileNavRegion").delegate("a", "click", function () {
//        appFunctions.closeMobile();
//    });
//    $("a[href='Terms'], a[href='PrivacyPolicy']").click(function (e) {
//        e.preventDefault();

//        var href = $(this).attr("href");
//        switch (href) {
//            case "Terms":
//                pf.navigate("terms");
//                break;
//            case "TermsCNB":
//                pf.navigate("termsCNB");
//                break;
//            case "PrivacyPolicy":
//                pf.navigate("privacypolicy");
//                break;
//        };
//    });
//};
function setupFunctions() {
	$.fn.serializeObject = function () {
		var o = {};
		var a = this.serializeArray();
		$.each(a, function () {
			if (o[this.name] !== undefined) {
				if (!o[this.name].push) {
					o[this.name] = [o[this.name]];
				}
				o[this.name].push(this.value || '');
			} else {
				o[this.name] = this.value || '';
			}
		});
		return o;
	};
	$.fn.outerHTML = function (s) {
		return s
			? this.before(s).remove()
			: jQuery('<p>').append(this.eq(0).clone()).html();
	};
	$.fn.outerHTML2 = function () {
		return !this.length
			? this
			: this[0].outerHTML ||
					(function (el) {
						var div = document.createElement('div');
						div.appendChild(el.cloneNode(true));
						var contents = div.innerHTML;
						div = null;
						return contents;
					})(this[0]);
	};
	$.date = function (dateObject) {
		var d = new Date(dateObject);
		var day = d.getDate();
		var month = d.getMonth() + 1;
		var year = d.getFullYear();
		if (day < 10) {
			day = '0' + day;
		}
		if (month < 10) {
			month = '0' + month;
		}
		var date = month + '/' + day + '/' + year;

		return date;
	};
	addBrowserProperty();
	// Needed to overide display properties of mobile elements they cannot be
	// var adjust_layout = _.debounce(browserResize, 300);
	$(window).resize(browserResize);
}
function extendLib() {
	if (typeof String.prototype.startsWith != 'function') {
		String.prototype.startsWith = function (str) {
			return this.slice(0, str.length) == str;
		};
	}
	if (typeof String.prototype.endsWith != 'function') {
		String.prototype.endsWith = function (str) {
			return this.slice(-str.length) == str;
		};
	}
}
function addBrowserProperty() {
	var matched, browser;

	jQuery.uaMatch = function (ua) {
		ua = ua.toLowerCase();

		var match =
			/(chrome)[ \/]([\w.]+)/.exec(ua) ||
			/(webkit)[ \/]([\w.]+)/.exec(ua) ||
			/(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
			/(msie) ([\w.]+)/.exec(ua) ||
			(ua.indexOf('compatible') < 0 &&
				/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
			[];

		return {
			browser: match[1] || '',
			version: match[2] || '0',
		};
	};

	matched = jQuery.uaMatch(navigator.userAgent);
	browser = {};

	if (matched.browser) {
		browser[matched.browser] = true;
		browser.version = matched.version;
	}

	// Chrome is Webkit, but Webkit is also Safari.
	if (browser.chrome) {
		browser.webkit = true;
	} else if (browser.webkit) {
		browser.safari = true;
	} else if (msieValid) {
		browser.msie = true;
		browser.mozilla = false;
	}

	jQuery.browser = browser;
}
function setupCookieCheck() {
	$.freeTheCookies({
		blockHtml:
			"PayForward needs <em>cookies</em> to offer its services. By using our services you're accepting our <a href='Terms.html'>terms of service</a>. <button id='explicit-consent'>Allow</button>",
		onUserAction: function (e) {
			var $target = $(e.target);
			if ($('body').hasClass('cookie-neutral') && e.type === 'scroll') {
				return false;
			}
			if (
				$target.hasClass('cookie-neutral') ||
				$target.parents('.cookie-neutral').length > 0
			) {
				return false;
			}
			return true;
		},
		onConsent: function () {},
	});
	//$("#remove-consent").bind("click", function () {
	//    $.removeCookie("cookie-consent", { path: "/" });
	//    location.reload();
	//});
	//$("#check-consent").bind("click", function () {
	//    if ($.freeTheCookies()) {
	//    } else {
	//        $.freeTheCookies(function () {
	//        });
	//    }
	//});
	$('#explicit-consent').bind('click', function () {
		$.freeTheCookies.now();
	});
}
function browserCheck() {
	if (
		($.browser.msie && parseInt($.browser.version) < 10) ||
		($.browser.mozilla && parseInt($.browser.version) < 20)
	) {
		pf.navigate('browserwarning');
	}
}
function haveCookieConcent() {
	if ($.freeTheCookies()) {
		return true;
	} else {
		return false;
	}
}
function getHostName(url) {
	var m = url.match(/^http:\/\/[^/]+/);
	return m ? m[0] : null;
}
function stringToUnicodeBytes(e) {
	for (var i = 0, bytes = [], l = e.length; i < l; i++) {
		bytes.push(e.charCodeAt(i));
		bytes.push(0);
	}
	return bytes;
}
function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel, Headers) {
	var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
	var CSV = '';
	var row = '';

	CSV += ReportTitle + '\r\n\n';

	if (ShowLabel) {
		for (var aIndex in arrData[0]) {
			for (var a = 0; a < Headers.length; a++) {
				if (Headers[a].toUpperCase() === aIndex.toUpperCase()) {
					row += aIndex + ',';
					break;
				}
			}
		}
		row = row.slice(0, -1);
		CSV += row + '\r\n';
	}

	for (var i = 0; i < arrData.length; i++) {
		row = '';
		for (var index in arrData[i]) {
			for (var j = 0; j < Headers.length; j++) {
				if (Headers[j].toUpperCase() === index.toUpperCase()) {
					row += '"' + arrData[i][index] + '",';
					break;
				}
			}
		}
		row.slice(0, row.length - 1);
		CSV += row + '\r\n';
	}

	if (CSV === '') {
		alert('Invalid data');
		return;
	}

	var fileName = '';
	fileName += ReportTitle.replace(/ /g, '_');

	var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

	var link = document.createElement('a');
	link.href = uri;
	link.style = 'visibility:hidden';
	link.download = fileName + '.csv';

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}
function formatCurrency(total) {
	var neg = false;
	if (total < 0) {
		neg = true;
		total = Math.abs(total);
	}
	return (
		(neg ? '-$' : '$') +
		parseFloat(total, 10)
			.toFixed(2)
			.replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
			.toString()
	);
	// return parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
}
function formatBalanceCurrency(total) {
	var neg = false;
	if (total < 0) {
		neg = true;
		total = Math.abs(total);
	}
	return (
		(neg ? '-$' : '$') +
		parseFloat(total, 10)
			.toFixed(2)
			.replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
			.toString()
	);
	//return parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
}
function formatPhone(text, beautify) {
	if (text) {
		text = text.toString().replace(/\D/g, ''); // stringify & remove non-numeric characters
		if (!beautify) {
			return text.toString().replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'); // format like: (123) 456-7890
		} else {
			return text;
		}
	}
}
function formatTime(time, isString, stringFormat) {
	/* ex: 12:34p instead of 12:34pm */
	if (isString) return moment(time, stringFormat).format('h:mma').slice(0, -1);
	/* datetime */ else return moment(time).format('h:mma').slice(0, -1);
}
function buildImageURL(
	entityType,
	entityGUID,
	imageTypeGUID,
	fileName,
	redirect
) {
	if (redirect !== false) {
		redirect = true;
	}
	if (!isEmpty(fileName)) {
		return (
			pf.imageURL +
			(
				'/' +
				entityType +
				'/' +
				entityGUID +
				'/' +
				imageTypeGUID +
				'/' +
				fileName +
				'/'
			).toLowerCase() +
			'?Redirect=' +
			redirect
		);
	}
	return '';
}
function buildMerchantImageURL(
	entityType,
	entityGUID,
	imageTypeGUID,
	fileName,
	redirect
) {
	if (redirect !== false) redirect = true;
	if (!isEmpty(fileName)) {
		return (
			pf.imageURL +
			(
				'/' +
				entityType +
				'/' +
				entityGUID +
				'/' +
				imageTypeGUID +
				'/' +
				fileName
			).toLowerCase()
		);
	}
	return '';
}
function getImageRedirectURL(url) {
	var rURL = '';
	$.ajax({
		async: false,
		type: 'GET',
		url: url,
		success: function (response, status, jqxhr) {
			rURL = response.location;
		},
		error: function (response, status, jqxhr) {
			var u = 0;
		},
	});
	return rURL;
}
function getSiteContent(file_obj, merge, callback) {
	var rt = null;
	$(document).ready(function () {
		$.ajax({
			type: 'GET',
			dataType: 'json',
			url: 'content/' + file_obj.B,
			success: function (response, status, jqxhr) {
				// console.log('getSiteContent ajax success',response);

				getSecondContentFile(file_obj, response, merge, callback);
			},
			error: function (response, status, jqxhr) {
				console.log('getSiteContent error', response, status, jqxhr);
			},
		});
	});
}

function getSecondContentFile(file_obj, base_data, merge, callback) {
	$.ajax({
		type: 'GET',
		dataType: 'json',
		url: 'content/' + file_obj.P,
		success: function (response, status, jqxhr) {
			var result = merge(base_data, response);

			// console.log('getSecondContentFile ajax success', base_data, response, result);

			getFeatures(result, callback);
		},
		error: function (response, status, jqxhr) {
			console.log('getSecondContentFile error', response, status, jqxhr);
		},
	});
}

function getFeatures(result, callback) {
	var url = pf.awsUrl + '/features',
		user_guid = pf.session.get('UserGUID');
	// user_guid = '76214f32e3a411e8af000e049fdf9c5c';

	if (!_.isObject(result) && result != null) {
		url = url + ('?alt_id=' + result);
	} else if (user_guid) {
		url = url + ('?user_id=' + user_guid);
	}

	$.ajax({
		type: 'GET',
		url: url,
		contentType: 'application/json',
		success: function (response, status, jqxhr) {
			// console.log('getFeatures success',response, status, jqxhr);

			if (_.isFunction(callback)) {
				if (_.isObject(result)) {
					callback(result, response);
				} else {
					callback(response);
				}
			}
		},
		error: function (response, status, jqxhr) {
			// console.log('getFeatures error',response, status, jqxhr);

			if (_.isFunction(callback)) {
				callback(result);
			}
		},
	});
}

function jsonpcallback(jj, resp) {
	debugger;
}
function getImageFileName(url) {
	if (!isEmpty(url)) {
		return url.substring(url.lastIndexOf('/') + 1);
	}
	return '';
}
function parseQueryString(queryString) {
	var params = {};
	if (queryString) {
		_.each(
			_.map(decodeURI(queryString).split(/&/g), function (el, i) {
				var aux = el.split('='),
					o = {};
				if (aux.length >= 1) {
					var val = undefined;
					if (aux.length == 2) val = aux[1];
					o[aux[0]] = val;
				}
				return o;
			}),
			function (o) {
				_.extend(params, o);
			}
		);
	}
	return params;
}
function getParameterByName(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
		results = regex.exec(location.search);
	return results === null
		? ''
		: decodeURIComponent(results[1].replace(/\+/g, ' '));
}
function encrypt(value) {
	if (!isEmpty(pf.pKey)) {
		var crypt = new JSEncrypt();
		crypt.setPublicKey(pf.pKey);
		return crypt.encrypt(value);
	}
	return value;
}
function getDictionaryValue(array, key) {
	///
	/// To get dictionary value from key
	///
	var result;
	$.each(array, function (k, v) {
		if (k == key) {
			result = v;
			return false;
		}
	});
	return result;
}
function IsMoney(amount) {
	var regex = /^\d+(?:\.\d{0,2})$/;
	return regex.test(amount.replace(',', ''));
}
function amountOfType(num, type) {
	if (num !== undefined) {
		var text = num.toString() + ' ' + type;
		if (num != 1) {
			return text + 's';
		} else {
			return text;
		}
	} else {
		return '';
	}
}
function deleteAllCookies() {
	var cookies = document.cookie.split(';');

	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i];
		var eqPos = cookie.indexOf('=');
		var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
	}
}
function pfrequire(viewpath, callback, subNav, options, createNew) {
	if (pf.currentviewpath != viewpath || createNew === true) {
		pf.currentviewpath = viewpath;

		require([String(viewpath)], function (view) {
			if (callback) callback(view);
		});
	} else if (pf.currentView) {
		pf.currentView.displaySubnav(subNav, options);
	} else {
		require([String(viewpath)], function (view) {
			if (callback) callback(view);
		});
	}
}
function setupCookieEnvironment(domain, secure) {
	//$.cookie.defaults.expires = 7;
	$.cookie.defaults.path = '/';
	if (!isEmpty(domain)) $.cookie.defaults.domain = domain;
	if (secure !== undefined) $.cookie.defaults.secure = secure;
}
function validateFileSize(size, type) {
	var isValid = true;

	switch (type) {
		default:
			if ((size / 1000000).toFixed(2) >= 5) {
				jAlert('Please choose a file with size  less than 5MB.'); //TODO: Change text
				isValid = false;
			}
			break;
	}
	return isValid;
}
function formatFileSize(bytes) {
	if (typeof bytes !== 'number') {
		return '';
	}

	if (bytes >= 1000000000) {
		return (bytes / 1000000000).toFixed(2) + ' GB';
	}

	if (bytes >= 1000000) {
		return (bytes / 1000000).toFixed(2) + ' MB';
	}

	return (bytes / 1000).toFixed(2) + ' KB';
}
function getApplicationControl(id) {
	var controls = pf.session.get('ApplicationControls');

	if (controls) {
		var model = _.find(controls.models, function (ac) {
			if (ac.Key == id) return ac;
		});

		return model.Value;
	}
	return;
}
function getApplicationControlByName(name) {
	var controls = pf.session.get('ApplicationControls');

	if (controls) {
		var model = _.find(controls.models, function (ac) {
			if (ac.Name == name) return ac;
		});

		if (model) return model.Value;
		else return undefined;
	}
	return;
}
function isEmail(email) {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	var res = regex.test(email);
	return res;
}
function genLinkURL(linkType, option1, option2) {
	switch (linkType) {
		case enums.linkType.user:
			return '#user/' + option1 + '/profile';
		case enums.linkType.cause:
			return '#causes/' + option1;
		case enums.linkType.merchantInfo:
			if (option2) return '#merchants/groups/' + option1 + '/info/' + option2;
			else return '#merchants/groups/' + option1 + '/info';
		case enums.linkType.causePostDetail:
			return '#causes/' + option1 + '/updates/' + option2;
		case enums.linkType.accountDetail:
			return '#wallet/' + option1;
		case enums.linkType.transferMoney:
			return '#wallet/transfermoney/' + option1;
		case enums.linkType.zCardAccountDetail:
			return '#wallet/zcards/' + option1;
	}
}
function genAvatar(avatarType, img, guid, guid2) {
	if (isEmpty(img)) {
		/* placeholders */
		switch (avatarType) {
			case enums.avatarType.user:
				return (
					"<a class='avatar link placeholder grey svgWrap' href='#user/" +
					guid +
					"/profile'>" +
					enums.svg.userOutline +
					'</a>'
				);
			case enums.avatarType.cause:
				return (
					"<a class='avatar link placeholder grey svgWrap cause' href='#causes/" +
					guid +
					"'>" +
					enums.svg.heartOutline +
					'</a>'
				);
			case enums.avatarType.merchant:
				return (
					"<a class='avatar link placeholder grey svgWrap' href='#merchants/groups/" +
					guid +
					'/info/' +
					guid2 +
					"'>" +
					enums.svg.priceTagOutline +
					'</a>'
				);
			case enums.avatarType.causeCard:
				return (
					"<a class='avatar previewCard__avatar placeholder svgWrap' href='#causes/" +
					guid +
					"'>" +
					enums.svg.heartOutline +
					'</a>'
				);
			case enums.avatarType.merchantCard:
				if (guid2)
					return (
						"<a class='avatar previewCard__avatar placeholder svgWrap' href='#merchants/groups/" +
						guid +
						'/info/' +
						guid2 +
						"'>" +
						enums.svg.priceTagOutline +
						'</a>'
					);
				else
					return (
						"<a class='avatar previewCard__avatar placeholder svgWrap' href='#merchants/groups/" +
						guid +
						"/info'>" +
						enums.svg.priceTagOutline +
						'</a>'
					);
			case enums.avatarType.onlineMerchantCard:
				return (
					"<i class='avatar previewCard__avatar placeholder svgWrap'>" +
					enums.svg.priceTagOutline +
					'</i>'
				);
			case enums.avatarType.causeImgOnly:
				return (
					"<i class='avatar placeholder grey svgWrap cause'>" +
					enums.svg.heartOutline +
					'</i>'
				);
			case enums.avatarType.merchantMicro:
				return (
					"<i class='avatar placeholder grey svgWrap merchantMicroGroupAvatar'>" +
					enums.svg.priceTagOutline +
					'</i>'
				);
			case enums.avatarType.merchantImgOnly:
				return (
					"<i class='avatar placeholder grey svgWrap'>" +
					enums.svg.priceTagOutline +
					'</i>'
				);
			case enums.avatarType.merchantLocation:
				return (
					"<a class='avatar link placeholder grey svgWrap' href='#merchants/groups/" +
					guid +
					'/info/' +
					guid2 +
					"'>" +
					enums.svg.priceTagOutline +
					'</a>'
				);
		}
	} else {
		/* image */
		switch (avatarType) {
			case enums.avatarType.user:
				return (
					"<a href='#user/" +
					guid +
					"/profile' class='avatar custom link' style='background-image:url(" +
					img +
					")'></a>"
				);
			case enums.avatarType.cause:
				return (
					"<a href='#causes/" +
					guid +
					"' class='avatar custom link' style='background-image:url(" +
					img +
					")'></a>"
				);
			case enums.avatarType.merchant:
				return (
					"<a href='#merchants/groups/" +
					guid +
					'/info/' +
					guid2 +
					"' class='avatar custom link' style='background-image:url(" +
					img +
					")'></a>"
				);
			case enums.avatarType.causeCard:
				return (
					"<a href='#causes/" +
					guid +
					"' class='avatar previewCard__avatar custom' style='background-image:url(" +
					img +
					");'></a>"
				);
			case enums.avatarType.merchantCard:
				if (guid2)
					return (
						"<a href='#merchants/groups/" +
						guid +
						'/info/' +
						guid2 +
						"' class='avatar previewCard__avatar custom' style='background-image:url(" +
						img +
						")'></a>"
					);
				else
					return (
						"<a href='#merchants/groups/" +
						guid +
						"/info' class='avatar previewCard__avatar custom' style='background-image:url(" +
						img +
						")'></a>"
					);
			case enums.avatarType.onlineMerchantCard:
				return (
					"<i class='avatar previewCard__avatar custom' style='background-image:url(" +
					img +
					");'></i>"
				);
			case enums.avatarType.causeImgOnly:
				return (
					"<i class='avatar custom' style='background-image:url(" +
					img +
					");'></i>"
				);
			case enums.avatarType.merchantMicro:
				return (
					"<i class='avatar custom merchantMicroGroupAvatar' style='background-image:url(" +
					img +
					");'></i>"
				);
			case enums.avatarType.merchantImgOnly:
				return (
					"<i class='avatar custom' style='background-image:url(" +
					img +
					");'></i>"
				);
			case enums.avatarType.merchantLocation:
				return (
					"<a class='avatar link custom' style='background-image:url(" +
					img +
					");' href='#merchants/groups/" +
					guid +
					'/info/' +
					guid2 +
					"'></a>"
				);
			case enums.avatarType.merchantEcard:
				return (
					"<i class='avatar custom merchantEcardImg' style='background-image:url(" +
					img +
					");'></i>"
				);
		}
	}
}
function genCauseTypeIcon(accountTypeID) {
	switch (accountTypeID) {
		case enums.accountTypeEnum.NonProfit:
			return (
				"<i class='svgIcon svgIcon--heartCertified' title='Certified Nonprofit'>" +
				enums.svg.heartCertified +
				'</i>'
			);
		case enums.accountTypeEnum.PayForwardCertifiedCause:
			return (
				"<i class='svgIcon svgIcon--heartCertified' title='Verified Cause'>" +
				enums.svg.heartCertified +
				'</i>'
			);
	}
	return '';
}
function genSymbol(symbol) {
	var symbolCode;
	switch (symbol) {
		case 'c':
			symbolCode = '&#169;';
			break;
		case 'r':
			symbolCode = '&#174;';
			break;
		case 'tm':
			symbolCode = '&#8482;';
			break;
		default:
			symbolCode = 'ERROR';
	}
	return '<small><sup>' + symbolCode + '</sup></small>';
}
function removeToken() {
	var name = 'token';
	if (Modernizr.localstorage) {
		localStorage.setItem(name, null);
	} else {
		$.removeCookie(name, { path: '/' });
	}
}
function isInApp() {
	if (pf.isMobile() && pf.session.inApp) {
		removeToken();
		window.location = 'payforward://close';
		return true;
	}
	return false;
}
function hideHeader() {
	$('#header-container').addClass('hidden');
}
function addTooltip(selector, errorMessage) {
	var item = selector;
	item.tooltipster({
		// position: 'right'
	});
	//item.addClass("tooltipstered");
	item.addClass('hasError');
	if (item.hasClass('md-input')) {
		item.parent().find('.md-input-bar').addClass('error');
	}
	item.tooltipster('enable');
	item.tooltipster('content', errorMessage);
}
function removeTooltip(selector) {
	var item = selector;
	item.tooltipster();
	item.removeClass('hasError');
	if (item.hasClass('md-input')) {
		item.parent().find('.md-input-bar').removeClass('error');
	}
	item.tooltipster('hide');
	item.tooltipster('disable');
	//item.removeClass("tooltipstered");
}
function showToolTip(e) {
	if (e && e.preventDefault) {
		e.preventDefault();
	}
	if (e && e.stopPropagation) {
		e.stopPropagation();
	}
	var item = e.target;
	if (item.tooltipster) {
		item.tooltipster('enable');
		item.tooltipster('show');
	}
}
// --------------------------------------------------------------
// FORM VALIDATION DOM INTERACTION (David F)
// (Phasing out in favor or Material styles - below)
// --------------------------------------------------------------

// Building Blocks: Styling Inputs & Validation Messages: -------
function styleInputValid(inputSelector) {
	if ($.isArray(inputSelector)) {
		// array of selectors
		$.each(inputSelector, function (index, el) {
			el.removeClass('hasError').addClass('isValid');
			if (el.hasClass('md-input')) {
				el.parent().find('.md-input-bar').removeClass('error');
				el.parent().find('.md-input-label').removeClass('error');
			}
		});
	} else {
		// single selectors
		inputSelector.removeClass('hasError').addClass('isValid');
		if (inputSelector.hasClass('md-input')) {
			inputSelector.parent().find('.md-input-bar').removeClass('error');
			inputSelector.parent().find('.md-input-label').removeClass('error');
		}
	}
}
function styleInputError(inputSelector) {
	if ($.isArray(inputSelector)) {
		// array of selectors
		$.each(inputSelector, function (index, el) {
			el.removeClass('isValid').addClass('hasError');
			if (el.hasClass('md-input')) {
				el.parent().find('.md-input-bar').addClass('error');

				if (el.hasClass('md-input--filled')) {
					el.parent().find('.md-input-label').addClass('error');
				}
			}
		});
	} else {
		// single selectors
		inputSelector.removeClass('isValid').addClass('hasError');
		if (inputSelector.hasClass('md-input')) {
			inputSelector.parent().find('.md-input-bar').addClass('error');

			if (inputSelector.hasClass('md-input--filled')) {
				inputSelector.parent().find('.md-input-label').addClass('error');
			}
		}
	}
}
function styleInputDefault(inputSelector) {
	if ($.isArray(inputSelector)) {
		// array of selectors
		$.each(inputSelector, function (index, el) {
			el.removeClass('isValid hasError');
			if (el.hasClass('md-input')) {
				el.parent().find('.md-input-bar').addClass('error');

				if (el.hasClass('md-input--filled')) {
					el.parent().find('.md-input-label').addClass('error');
				}
			}
		});
	} else {
		// single selectors
		inputSelector.removeClass('isValid hasError');
		if (inputSelector.hasClass('md-input')) {
			inputSelector.parent().find('.md-input-bar').removeClass('error');
			inputSelector.parent().find('.md-input-label').removeClass('error');
		}
	}
}
function addErrorMsg(messageSelector, message) {
	if (messageSelector.hasClass('md-input')) {
		messageSelector.parent().find('.md-input-bar').addClass('error');

		if (messageSelector.hasClass('md-input--filled')) {
			messageSelector.parent().find('.md-input-label').addClass('error');
		}
	}
	messageSelector.html(message);
}
function removeErrorMsg(messageSelector) {
	if (messageSelector.hasClass('md-input')) {
		messageSelector.parent().find('.md-input-bar').removeClass('error');
		messageSelector.parent().find('.md-input-label').removeClass('error');
	}
	messageSelector.empty();
}

// Common Combinations:
function feedbackValid(inputSelector, messageSelector) {
	styleInputValid(inputSelector);
	removeErrorMsg(messageSelector);
}
function feedbackError(inputSelector, messageSelector, message) {
	styleInputError(inputSelector);
	addErrorMsg(messageSelector, message);
}
function feedbackClear(inputSelector, messageSelector) {
	styleInputDefault(inputSelector);
	removeErrorMsg(messageSelector);
}

// -----------------------------
// Material Design Input Functions
// -----------------------------

// Determines if input label will be allowed to cover input.
function handleMDInputLabel(elInput) {
	if (elInput.val() == '') {
		elInput.removeClass('md-input--filled');
	} else {
		elInput.addClass('md-input--filled');
	}
}

// Returns the feedback element associated with a material input
function getMDInputFeedbackEl(elInput) {
	var elFeedback = elInput.siblings('.md-input-feedback');
	if (elFeedback.length) {
		return elFeedback;
	} else {
		return false;
	}
}

// Changes CSS classes to style input invalid
function styleMDInputInvalid(elInput) {
	elInput.addClass('md-input--invalid');
}
// Removes valid/invalid CSS classes from input, leaving default styles.
function styleMDInputDefault(elInput) {
	elInput.removeClass('md-input--invalid');
}

// Adds a validation message to a container
function addMDFeedback(elFeedback, feedback) {
	elFeedback.html(feedback);
}
// Only use this when the feedback element is outside the md-input-group, because
// usually the feedback color styles are determined by sibling input classes.
function addMDErrorFeedback(elFeedback, feedback) {
	elFeedback.addClass('md-input-feedback--invalid');
	addMaterialFeedback(elFeedback, feedback);
}
// Removes a validation message to a container
function removeMDFeedback(elFeedback) {
	elFeedback.removeClass('md-input-feedback--invalid').empty();
}

// --------------------------------------------------------------

function isValidJSON(text) {
	try {
		JSON.parse(text);
		return true;
	} catch (e) {
		console.log('invalid JSON', e);

		return false;
	}
}

function getToken() {
	var name = 'token';
	var value = null;
	if (Modernizr.localstorage) {
		if (isValidJSON(localStorage.getItem(name))) {
			value = JSON.parse(localStorage.getItem(name));
		} else {
			removeToken();
		}
	} else {
		value = $.cookie(name);
	}
	return value;
}
function setToken(value, minutes) {
	var name = 'token';
	var date = new Date();
	if (Modernizr.localstorage) {
		localStorage.setItem(name, JSON.stringify(value));
	} else {
		if (minutes > 0) {
			date.setTime(date.getTime() + minutes * 60 * 1000);
			$.cookie(name, value, { path: '/', expires: date });
		} else {
			$.cookie(name, value, { path: '/' });
		}
	}
}

function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
	//If JSONData is not an object then JSON.parse will parse the JSON string in an Object
	var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

	var CSV = '';
	//Set Report title in first row or line

	CSV += ReportTitle + '\r\n\n';

	//This condition will generate the Label/Header
	if (ShowLabel) {
		var row = '';

		//This loop will extract the label from 1st index of on array
		for (var index in arrData[0]) {
			//Now convert each value to string and comma-seprated
			row += index + ',';
		}

		row = row.slice(0, -1);

		//append Label row with line break
		CSV += row + '\r\n';
	}

	//1st loop is to extract each row
	for (var i = 0; i < arrData.length; i++) {
		var row = '';

		//2nd loop will extract each column and convert it in string comma-seprated
		for (var index in arrData[i]) {
			row += '"' + arrData[i][index] + '",';
		}

		row.slice(0, row.length - 1);

		//add a line break after each row
		CSV += row + '\r\n';
	}

	if (CSV == '') {
		alert('Invalid data');
		return;
	}

	//Generate a file name
	var fileName = 'Report_';
	//this will remove the blank-spaces from the title and replace it with an underscore
	fileName += ReportTitle.replace(/ /g, '_');

	//Initialize file format you want csv or xls
	var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

	// Now the little tricky part.
	// you can use either>> window.open(uri);
	// but this will not work in some browsers
	// or you will not get the correct file extension

	//this trick will generate a temp <a /> tag
	var link = document.createElement('a');
	link.href = uri;

	//set the visibility hidden so it will not effect on your web-layout
	link.style = 'visibility:hidden';
	link.download = fileName + '.csv';

	//this part will append the anchor tag and remove it after automatic click
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}
function checkAccess(route) {
	var cardType = pf.session.get('CardType');
	var rVal = false;

	if (pf.session.get('ZuserAccess') == true) return true;

	if (cardType == enums.cardTypes.ZCard) {
		$.ajax({
			type: 'GET',
			async: false,
			url: pf.userURL + '/VerifyAccountAccess/' + cardType,
			contentType: 'application/json',
			success: function (response) {
				pf.session.set('ZuserAccess', true);
				rVal = true;
			},
			error: function (response) {
				rVal = false;
			},
		});
	} else {
		rVal = true;
	}

	if (
		!rVal &&
		route != 'cardholderagreement' &&
		route != 'privacypolicy(/:HideHeader)' &&
		route != 'terms(/:HideHeader)'
	)
		pf.navigate('zcardterms');
	else return rVal;
}
function getResource(contentGroup, contentKey) {
	var result = $.grep(resourceContent, function (e) {
		return e.CG == contentGroup && e.CK == contentKey;
	});

	if (result.length == 0) {
		return null;
	} else {
		return result[0].CV;
	}
}

//DisplayTimeOnly indicates if it's the same day or within 12 hours from deal
//Display soon indicates that that instead of long version for the upcoming rebate, we just use the word 'soon'. Current used in search
function getRebateString(
	NextRebatePercentage,
	NextRebateTime,
	DisplayTimeOnly,
	DisplaySoon
) {
	var displayString = '';

	if (DisplayTimeOnly) {
		displayString =
			NextRebatePercentage + '% at ' + moment(NextRebateTime).format('h:mma');
	} else {
		if (DisplaySoon) displayString = NextRebatePercentage + '% soon';
		else
			displayString =
				NextRebatePercentage +
				'% on ' +
				moment(NextRebateTime).format('ddd M/D') +
				' at ' +
				moment(NextRebateTime).format('h:mma');
	}
	return displayString;
}
function scrollToElement(element, time) {
	var element = element != '#' ? element : 'html,body',
		time = time || 700;
	$('html, body').animate(
		{
			scrollTop: $(element).offset().top,
		},
		time
	);
}
function gAnalytics(Action, Label, LabelValue, page) {
	gAnalyticsCategory('Consumer', Action, Label, LabelValue, page);
}
function gAnalyticsCategory(Category, Action, Label, LabelValue, page) {
	store.getStoreItem(
		enums.modelsEnum.ReferralCode,
		null,
		false,
		false,
		false,
		function (data) {
			var referralCode = data;
			if (referralCode != null || referralCode != undefined)
				Label = Label + ' - ReferralCode: ' + referralCode;

			ga('send', {
				hitType: 'event',
				eventCategory: Category,
				eventAction: LabelValue,
				eventLabel: Label,
			});
		}
	);
}
function saveAffiliateClick(merchantGUID) {
	$.ajax({
		type: 'PUT',
		url: pf.merchantsURL + '/Affiliate/' + merchantGUID,
		contentType: 'application/json',
		async: true,
	});
}
function browserResize() {
	var width = $(window).width(),
		page = window.location.hash,
		mobileMenu = $('#mobile-menu'),
		mobileMenuCloseBtn = $('#mobile-menu-close-icon'),
		mobileMenuIcon = $('#mobile-menu-icon'),
		isPartner = $('#partner-logo').length > 0,
		isFluid = $('html.fluid').length > 0,
		isLanding = window.location.hash == '' ? true : false;

	// Desktop breakpoint
	if (width > 1024) {
		// Check to see if mobile menu is open, if so hide mobile close button if it is visible
		if (
			mobileMenu.is(':visible') ||
			mobileMenuIcon.is(':visible') ||
			mobileMenuCloseBtn.is(':visible')
		) {
			mobileMenuIcon.css('display', 'none');
			mobileMenuCloseBtn.css('display', 'none');

			// if(mobileMenuCloseBtn.is(':visible')){
			//     mobileMenuCloseBtn.css('display','none');
			// }
			// // Anthem specific toggling
			if (isPartner && mobileMenuIcon.is(':visible')) {
				mobileMenuIcon.css('display', 'block');
			}
		}
	} else if (width < 1025 && width > 667) {
		// Tablet breakpoint
		mobileMenuCloseBtn.css('display', 'none');
		if (mobileMenu.is(':visible')) {
			if (!mobileMenuCloseBtn.is(':visible')) {
				mobileMenuCloseBtn.css('display', 'block');
			}
		}
		if (!mobileMenuIcon.is(':visible')) {
			mobileMenuIcon.css('display', 'block');
		}
		// Anthem specific toggling
		if (isPartner) {
			// mobileMenuCloseBtn.css('display','none');
			// mobileMenuIcon.css('display','none');
			mobileMenu.css('display', 'none');
		}
	} else if (width < 668) {
		// Mobile Landscape breakpoint
		mobileMenuCloseBtn.css('display', 'none');
		if (mobileMenu.is(':visible')) {
			if (!mobileMenuCloseBtn.is(':visible')) {
				mobileMenuCloseBtn.css('display', 'block');
			}
		} else if (!mobileMenuIcon.is(':visible') && isPartner && !isFluid) {
			mobileMenuIcon.css('display', 'block');
		} else if (!mobileMenuIcon.is(':visible') && !isPartner && isFluid) {
			mobileMenuIcon.css('display', 'block');
		} else if (!mobileMenuIcon.is(':visible') && isPartner && isFluid) {
			mobileMenuIcon.css('display', 'block');
		}
	}
	if ($('.map-wrap')[0]) {
		$('.map-wrap')
			.find('#google-map .mapContainer')
			.css('height', $('.map-wrap').height() + 'px');
		google.maps.event.trigger(pf.maps.current, 'resize');
	}

	switch (page) {
		case '#wallet':
			resetWalletSlider();
			break;
		case '#home':
			startMapSizingInterval();
			resetHomeSliders();
			break;
		case '':
			startMapSizingInterval();
			resetHomeSliders();
			break;
	}
}

var MapSizingInterval = null;

function startMapSizingInterval() {
	MapSizingInterval = setInterval(function () {
		if (pf.maps.current) {
			var map_container_height = $('.js-merchant-map-container').height(),
				map_container_width = $('.js-merchant-map-container').width(),
				merchant_detail_container = $('.js-merchant-group-map');

			if (merchant_detail_container.length) {
				pf.maps.current.getDiv().style.height =
					merchant_detail_container.height() + 'px';
				pf.maps.current.getDiv().style.width =
					merchant_detail_container.width() + 'px';

				google.maps.event.trigger(pf.maps.current, 'resize');
			} else if (map_container_width > 0 && map_container_height > 0) {
				pf.maps.current.getDiv().style.height = map_container_height + 'px';
				pf.maps.current.getDiv().style.width = map_container_width + 'px';

				google.maps.event.trigger(pf.maps.current, 'resize');
			}
		}
	}, 3000);
}

function resetWalletSlider() {
	if (pf.wallet) {
		pf.wallet.resetPreview();
	}
}

function resetHomeSliders() {
	if (pf.home) {
		pf.home.resetPreviewSliders();
	}
}

function isSunsetting() {
	let terminated_programs = [
		enums.siteVersion.anthem,
		enums.siteVersion.rxsavings,
		enums.siteVersion.bcbsaz,
		enums.siteVersion.bcbsla,
		enums.siteVersion.bluekc,
	];

	return terminated_programs.includes(pf.getContent('version.id'));
}

function handlePartnerDiffs() {
	var isPartner = $('#partner-logo').length > 0,
		isBcbsla = $('.bcbsla_logo').length > 0,
		isBluekc = $('.bluekc_partner_logo').length > 0,
		isLanding = window.location.hash == '' ? true : false,
		isLoggedOut = pf.session.get('auth') ? true : false,
		site_version = pf.getContent('version.id');

	var addFluidCls = function () {
		$('html').addClass('fluid');
		$('html').removeClass('anthemFluid');
		// TODO: pf session get takes too long, find another way to modify Partner menu on non-landing views
		if (site_version != enums.siteVersion.payforward) {
			$('html').addClass('fluidPartner');
		}
	};

	var addAnthemFluidCls = function () {
		$('html').removeClass('fluid');
		$('html').addClass('anthemFluid');
	};

	var clearBcbslaLandingCls = function () {
		$('#header-logged-out').removeClass('header-gradient');
		$('#header-logged-out').removeClass('link-colors-dark');
	};

	var addBcbslaLandingCls = function () {
		$('#header-logged-out').addClass('header-gradient');
		$('#header-logged-out').addClass('link-colors-dark');
	};

	if (isPartner) {
		if (isLanding) {
			if (!isBluekc) {
				addAnthemFluidCls();
			}

			if (isBcbsla) {
				addBcbslaLandingCls();
			}
		} else {
			addFluidCls();

			if (isBcbsla) {
				clearBcbslaLandingCls();
			}
		}
	}
}
function createReferenceNumber() {
	// Temporary time-based key generation of unique reference numbers
	// Ideally we would find a library for this that can be modified to allow
	// for the reference number to start with a letter and not a number
	var text = '',
		time = new Date().getTime(),
		nonNumericPossible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
		possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz' + time;

	for (var i = 0; i < 32; i++) {
		if (i == 0) {
			text += nonNumericPossible.charAt(
				Math.floor(Math.random() * nonNumericPossible.length)
			);
		} else {
			text += possible.charAt(Math.floor(Math.random() * possible.length));
		}
	}

	return text;
}
// Changes styles of children that have varients, such as .btn-default, etc
function skinForPartner($el) {
	var skinClass = getPartnerSkinClass();
	$el.addClass(skinClass);
}
function getPartnerSkinClass() {
	var site_version = pf.getContent('version.id'),
		site_name = pf.getContent('version.name');

	if (site_version == enums.siteVersion.payforward) {
		return '';
	} else {
		return 'skin-' + site_name;
	}
}
// CIP Status Check
function checkCipStatus() {
	if (pf.session.get('auth')) {
		// TODO: Replace session checking with endpoint check (checkCIP)
		if (
			pf.session.get('CIPStatus') == 1 ||
			pf.session.get('CIPStatus') == 4 ||
			pf.session.get('CIPStatus') == 6
		) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
}
// CIP
function getCipTriggerRoute() {
	return localStorage.getItem('triggerRoute');
}
function saveCipTriggerRoute(route) {
	var route = route || Backbone.history.getFragment();
	localStorage.setItem('triggerRoute', route);
}
function removeCipTriggerRoute() {
	localStorage.removeItem('triggerRoute');
}
// Global Notification Banner
function addNotificationBanner(content) {
	if (!$('#mainRegion').hasClass('notification-banner-container')) {
		$('#mainRegion').addClass('notification-banner');
		$('#mainRegion').prepend(
			'<div class="notification-banner-container">We need to verify your identity to complete your request.</div>'
		);
	}
}

function checkFinRegStatus(callback) {
	if (pf.session.get('auth')) {
		$.ajax({
			url: pf.authURL + '/Token/CheckFin',
			type: 'GET',
			async: false,
			contentType: 'application/json',
			success: function (resp, model) {
				if (_.isFunction(callback)) {
					callback(resp);
				}
			},
			error: function (resp, model) {
				if (resp.status == 401) {
					pf.session.cleanup(true);
					$.fancybox.close();

					pf.viewLogin(
						false,
						function (result) {
							var route = pf.getCurrentRoute();

							pf.navigate(route);
						},
						null,
						{ isNotPopup: false },
						false
					);
				}
			},
		});
	} else {
		pf.session.logout();
		pf.navigate('login');
	}
}

function goToFinancialRegistration(route) {
	// Take to Financial Registration if the User is not Financially Registered because you cannot CIP without being Financial
	if (!pf.IsConsumerFinancial) {
		var product = enums.cardTypes.VirtualCard;

		pf.controller.showMemberApplication(product, false);
	} else {
		if (route) {
			saveCipTriggerRoute(route);
		}
		pf.navigate('register/financial/cip', { trigger: true });
	}
}

function keyupCurrencyHandling(e) {
	var input = e.target,
		amounts = {
			number: Number($(input).val().replace('$', '').replace(/,/g, '')).toFixed(
				2
			),
			string: '$' + $(input).val().replace('$', ''),
		};
	return amounts;
}

function blurCurrencyHandling(e) {
	var input = e.target,
		value = $(input).val(),
		handle_duplicates = false,
		amounts = {
			number: -1,
			string: '',
		};

	// TODO: Handle duplicate special characters
	if (value.replace(/[^$]/g, '').length > 1) {
		handle_duplicates = true;
	}
	if (value.replace(/[^.]/g, '').length > 1) {
		handle_duplicates = true;
	}
	if (value.replace(/[^,]/g, '').length > 1) {
		handle_duplicates = true;
	}

	var formatted_number = Number(
		value.replace('$', '').replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
	).toFixed(2);

	// console.log('blurCurrencyHandling',value.replace('$','').replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),formatted_number);

	if (formatted_number.length - formatted_number.lastIndexOf('.') < 3) {
		formatted_number = formatted_number + 0;
	}

	if (formatted_number != 'NaN') {
		amounts.number = formatted_number;
		amounts.string = '$' + formatted_number;
	}

	if (!handle_duplicates) {
		amounts.number = Number(value.replace('$', '').replace(',', '')).toFixed(2);
		amounts.string =
			'$' + Number(value.replace('$', '').replace(',', '')).toFixed(2);
	}

	return amounts;
}

function startPanoScrollAnimator(selector, rate) {
	$(window).on('scroll', function () {
		panoScrollAnimator(selector, rate);
	});
}

function endPanoScrollAnimator(selector) {
	$(window).off('scroll');
}

function panoScrollAnimator(selector, rate) {
	var window_top = $(window).scrollTop(),
		bg_position = -Math.abs(window_top * rate);

	if (
		pf.getContent('version.id') == enums.siteVersion.bcbssc ||
		pf.getContent('version.id') == enums.siteVersion.csnp ||
		pf.getContent('version.id') == enums.siteVersion.centene ||
		pf.getContent('version.id') == enums.siteVersion.bcbskc
	) {
		bg_position = bg_position;
		// bg_position = bg_position + 72;
	}

	$(selector).css('background-position-y', bg_position);
}

function cipRequired() {
	var pass = false;

	if (pf.session.get('auth')) {
		switch (pf.session.get('CipStatusId')) {
			case enums.cipStatusId.unknown:
				pass = false;
				break;
			case enums.cipStatusId.passed:
				pass = false;
				break;
			case enums.cipStatusId.failed:
				pass = false;
				break;
			case enums.cipStatusId.soft_failed:
				pass = false;
				break;
			case enums.cipStatusId.skipped:
				pass = false;
				break;
			case enums.cipStatusId.pending:
				pass = true;
				break;
			case enums.cipStatusId.manually_passed:
				pass = false;
				break;
			case enums.cipStatusId.delayed:
				pass = false;
				break;
			case enums.cipStatusId.required:
				pass = true;
				break;
			default:
				pass = false;
				break;
		}

		return pass;
	} else {
		return pass;
	}
}

function refreshAuth(callback) {
	pf.session.getAuth(function () {
		if (_.isFunction(callback)) {
			callback();
		}
	});
}

function returnUrlQueryStringAsObject() {
	var query_string = window.location.search.substr(1).split('&'),
		query_object = {};

	if (query_string == '') {
		return {};
	}

	for (var i = 0; i < query_string.length; i++) {
		var query_item = query_string[i].split('=', 2);

		if (query_item.length == 1) {
			query_object[query_item[0]] = '';
		} else {
			query_object[query_item[0]] = decodeURIComponent(
				query_item[1].replace(/\+/g, ' ')
			);
		}
	}

	return query_object;
}
;
define("common/general", function(){});

